export const useDebugMode = (): boolean => {
  const urlHasDebug = new URLSearchParams(window.location.search).has('debug')
  return (
    urlHasDebug ||
    (window as unknown as Record<string, unknown>).__debug === true
  )
}
